// extracted by mini-css-extract-plugin
module.exports = {"redBorder":"FragmentComponent_redBorder__bqdxA"};